/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Cmp_Hero_Cta_SecondaryInputs */

const en_cmp_hero_cta_secondary = /** @type {(inputs: Cmp_Hero_Cta_SecondaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import from ${i?.name}`)
};

const id_cmp_hero_cta_secondary = /** @type {(inputs: Cmp_Hero_Cta_SecondaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impor dari ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Import from {name}" |
*
* @param {Cmp_Hero_Cta_SecondaryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_hero_cta_secondary = /** @type {((inputs: Cmp_Hero_Cta_SecondaryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Hero_Cta_SecondaryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_hero_cta_secondary(inputs)
	return en_cmp_hero_cta_secondary(inputs)
});